import './@vc-privacy/paramount-cmp-html5';
import config from 'config';

import { getUUID } from 'hooks/uuid';

const configuration: Record<string, string> = {
  organization: config.privacy.organization,
  property: config.privacy.property,
  language: 'en',
};
const identities: Record<string, string | null> = {
  paramount_privacy_id: getUUID('paramount_privacy_id'),
};
const environment = 'production';

const mockLocation: Record<string, string> = {
  // region: 'de',
  // jurisdiction: 'gdpr', // default, us_general, gdpr, quebec
};

const syncCMP = (): void => {
  if (window.cmp.consent.ready) {
    window.cmp.consent.sync();
  }
};

const PrivacyManager = {
  initializeCMP: (): void => {
    if (window.cmp?.consent?.ready) {
      return;
    }
    const cmp = new window.ParamountCmp(
      configuration,
      identities,
      mockLocation,
      environment,
      window.ParamountCmp.LogLevel.DEBUG,
    );

    window.cmp = cmp;

    window.cmp.addEventListener(
      window.ParamountCmp.PrivacyEvent.CONSENT_READY,
      syncCMP,
      { once: true },
    );
    cmp.load();
  },
};

export default PrivacyManager;
